/* eslint-disable import/prefer-default-export */
import { lazy } from '../../shared/deployment';

export const MeetingsStartsAtEndsAt = lazy(() => import('./MeetingsStartsAtEndsAt'));
